module.exports = __webpack_public_path__ + "img/ai-glass-tall.f419d55a.png";